export default __webpack_public_path__ + "2f988b0e45c237567721ed42117c9199.png";